import { FC, useContext, useEffect } from "react";
import ReactPlayer from "react-player";
import {
  Typography,
  Grid,
  Box,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router";
import moment from "moment";
import playicon from "../../assets/images/play.svg";
import videoplaceholder from "../../assets/images/videoplaceholder.jpg";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import BackButton from "../../helpers/BackButton";
import { animateScroll as scroll } from "react-scroll";
import { GetPoolQuizQuestionArgs, Quiz, StartQuizType } from "../../store/Learn2/learn.interface";
import PoolContext from "../../store/Pool/PoolContext";
import LearnContext, { useLearnContext } from "../../store/Learn2/LearnContext";

// setting min max for progressbar
// const MIN = 0;
// const MAX = 1;
// const normalise = (value: number) => ((value - MIN) * 100) / (MAX - MIN);

interface LearnVideoProps {
  quiz: Quiz;
  isActive: boolean;
  isActiveMD: boolean;
  quizIndex: number;
  resume: boolean;
  restart: boolean;
  getNextQuestion: (options: { startQuizType: StartQuizType }) => void;
}

const Playicon = () => {
  return <img src={playicon} alt="play" className="img-fluid" />;
};

const LearnVideo: FC<LearnVideoProps> = (props) => {

  const history = useHistory();
  const { getActivePool } = useContext<any>(PoolContext);
  const { quiz, isActive, isActiveMD, quizIndex, resume, restart, getNextQuestion } = props;

  // Fetch from currenty active pool or params
  const pool = getActivePool();
  console.info(pool);
  const poolId = pool.id;
  const live = pool.pledgeEndDate;
  const poolsTime = moment(live).format("YYYY-MM-DD (HH:mm:ss A)");

  const quizDuration = moment.duration(quiz?.timeLimitInSeconds, "seconds");
  const formattedQuizDuration = `${quizDuration.hours().toString().padStart(2, '0')}:${quizDuration.minutes().toString().padStart(2, '0')}:${quizDuration.seconds().toString().padStart(2, '0')}`;

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const handleQCMStart = (event: any) => {
    event.preventDefault();

    let startQuizType: StartQuizType = 'start'
    if(resume){
      startQuizType = 'resume'
    }else{
      if(restart){
        startQuizType = 'restart'
      }
    }
    getNextQuestion({
      startQuizType
    })
  };

  return (
    <>
        {
          quizIndex === 0 && (
            <>
              <Box mt={isActive ? 2 : 4}>
                <BackButton route={`project/${poolId}`} />
              </Box>
            </>
        )}

        <Box mt={isActive ? 3 : 5} ml={isActive ? 0 : 0}>
          <Box mb={2} p={0} mt={2}>
            <Typography variant="h2" color="secondary">
              Learn about{" "}
              <Typography component="span" variant="h2" color="primary">
                {pool?.name}
              </Typography>
              {" "} to get whitelisted
            </Typography>{" "}
            {/** typegrapic box */}
          </Box>
          <Box
            mt={isActive ? 2 : 3}
            mb={isActive ? 2 : 0}
            display="flex"
          >
            <Typography variant="h3" color="secondary">
              {quizIndex + 1}.
            </Typography>
            <Box ml={2} mb={1}>
              <Typography variant="h3" color="secondary">
                {quiz?.title.toUpperCase()}
              </Typography>
            </Box>
          </Box>
          <Box position="relative">
            <ReactPlayer
              className="video-clip"
              url={quiz?.lessonContent}
              width="100%"
              controls
              playIcon={<Playicon />}
            />
          </Box>
          <Box p={3} mt={2} className="box-border-main">
            <Typography variant="h4" color="secondary">
              Rules
            </Typography>

            <Box
              mt={2}
              display="flex"
              flexDirection={isActive ? "column" : "row"}
            >
              {" "}
              {/**main flex box */}
              <Box
                display="flex"
                flexDirection="column"
                mr={isActiveMD ? 2 : 5}
                mb={isActive ? "12px" : 0}
              >
                {" "}
                {/**flex box item */}
                <Typography
                  variant="body1"
                  color="primary"
                  className="fw-bold"
                >
                  {poolsTime}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="fw-normal text-darkslate"
                >
                  Deadline
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                mr={isActiveMD ? 2 : 5}
                mb={isActive ? "12px" : 0}
              >
                {" "}
                {/**flex box item */}
                <Typography
                  variant="body1"
                  color="primary"
                  className="fw-bold"
                >
                  3 Times
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="fw-normal text-darkslate"
                >
                  Attempts
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                mr={2}
                mb={isActive ? "12px" : 0}
              >
                {" "}
                {/**flex box item */}
                <Typography
                  variant="body1"
                  color="primary"
                  className="fw-bold"
                >
                  7/10
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="fw-normal text-darkslate"
                >
                  Needed to be successful
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                {" "}
                {/**flex box item */}
                <Typography
                  variant="body1"
                  color="primary"
                  className="fw-bold"
                >
                  {formattedQuizDuration}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="fw-normal text-darkslate"
                >
                  Quiz time limit
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box mt={ isActive ? 4 : 5 } mb={ isActive ? 3 : 10 }>
            <Button
              variant="contained"
              color="secondary"
              className="continue-button"
              onClick={handleQCMStart}
            >
              {
                resume
                ? "Resume"
                : restart
                  ? "Restart"
                  : "Start Quiz"
              }
            </Button>
          </Box>
        </Box>

    </>
  );
};

export default LearnVideo;
